import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheServiceMenu from "./sections/TheServiceMenu";
import BridalSpecialEvents from "./sections/BridalSpecialEvents";
import SiteFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <TheServiceMenu />
      <BridalSpecialEvents />
      <SiteFooter />
    </div>;
}